/**
 * User Permissions Constants
 * These constants define the permissions available in the system
 * and are used to control user access to different features.
 */

export const PERMISSIONS = {
  VIEW_OTHER_SCHEDULES: 'ViewOtherSchedules',
  MODIFY_APPOINTMENTS: 'ModifyAppointments',
  ACCESS_REMINDERS: 'AccessReminders',
  VIEW_CLIENT_BALANCE_FROM_APPOINTMENT: 'ViewClientBalanceFromAppointment',
  ACCESS_INVOICES: 'AccessInvoices',
  ACCESS_PAYMENTS: 'AccessPayments',
  ACCESS_DASHBOARD: 'AccessDashboard',
  ADD_EDIT_CLIENT: 'AddEditClient',
  ACCESS_CLIENT_FILES: 'AccessClientFiles',
  ACCESS_CLIENT_APPOINTMENTS: 'AccessClientAppointments',
  ACCESS_CLIENT_MEMBERSHIPS: 'AccessClientMemberships',
  ACCESS_CATALOG: 'AccessCatalog',
  ACCESS_EMPLOYEES: 'AccessEmployees',
  ACCESS_SETTINGS: 'AccessSettings',
  VIEW_CLIENT_WORKOUT_PLANS: 'ViewClientWorkoutPlans',
  ADD_WORKOUT_PLAN: 'AddWorkoutPlan',
  EDIT_WORKOUT_PLAN: 'EditWorkoutPlan',
  ACCESS_LIVE_WORKOUT: 'AccessLiveWorkout',

} as const;

/**
 * Type for permission values
 */
export type Permission = typeof PERMISSIONS[keyof typeof PERMISSIONS];

/**
 * Array of all permission values for easy iteration
 */
export const ALL_PERMISSIONS: Permission[] = Object.values(PERMISSIONS);

